module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"meta":{"title":"Susisiekti","description":"Susisiekite su mumis. Mes visada pasiruošę patarti visais jums rūpimais klausimais."},"offices":"Mūsų biurai","title":"Kontaktai"}}')
  delete Component.options._Ctor
}
